module.exports = {
  StartEndDateCannotEmpty: 'Start date or end date cannot be empty!',
  StartBeEarlierThanDate: 'Start date must be earlier than end date!',
  Continent: 'Continent',
  Route: 'Route',
  Network: 'Network',
  Currency: 'Currency',
  ContainerType: 'Container Type',
  Package: 'Package',
  BillOfLadingType: 'Bill of Lading Type',
  CargoType: 'Cargo Type',
  TradeTerms: 'Trade Terms',
  TransportationTerms: 'Transportation Terms',
  FreightTerms: 'Freight Terms',
  TradeMethod: 'Trade Method',
  CustomsDeclarationMethod: 'Customs Declaration Method',
  AirFreightServiceItem: 'Air Freight Service Item',
  RelatedPort: 'Related Port',
  AirWaybillSundryCharge: 'Air Waybill Sundry Charge',
  ClientType: 'Client Type',
  AppraisalCategory: 'Appraisal Category',
  ShippingDocumentMethod: 'Shipping Document Method',
  CustomBusinessType: 'Custom Business Type',
  TransitDocumentType: 'Transit Document Type',
  CommissionRule: 'Commission Rule',
  RailwayLine: 'Railway Line',
  ValueAddedService: 'Value-added Service',
  BilledUnitUnit: 'Billed Unit/Unit',
  HazardousGoods: 'Hazardous Goods',
  CargoInformation: 'Cargo Information',
  LiabilityReason: 'Liability Reason',
  ClientSource: 'Client Source',
  MultimodalTransportType: 'Multimodal Transport Type',
  VehicleType: 'Vehicle Type',
  CustomEqType: 'Custom EqType',
  CollaborativeBusinessType: 'Collaborative Business Type',
  Records: 'Record(s);',
  recordsImportedToTheSystem: '@records records successfully imported to the system!',
  Records2: 'Record(s)',
  Edit: 'Edit',
  Delete: 'Delete',
  Disable: 'Disable',
  Enable: 'Enable',
  AreWantToDeleteRecord: 'Are you sure you want to delete this record?',
  Reminder: 'Reminder',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  SuccessfullyDeleted: 'Successfully deleted!',
  DeletionCanceled: 'Deletion canceled',
  DoToOverwriteExistingData: 'Do you want to overwrite existing data?',
  Overwrite: 'Overwrite',
  PleaseSelectDataToExport: 'Please select data to export.',
  UploadedBeXlsOrFormat: 'Uploaded file can only be xls or xlsx format!',
  FileSizeCannotExceed2MB: 'File size cannot exceed 2MB',
  ImportPleaseContactTheAdministrator: 'Import failed, please contact the administrator.',
  DataExistingDataInTable: 'Data duplicated with existing data in the table!',
  SuccessfullyAdded: 'Successfully added',
  City: 'City',
  BusinessType: 'Business type',
  PlatformCustomerService: 'Platform customer service',
  Code: 'Code',
  Name: 'Name',
  ChineseName: 'Chinese name',
  EnglishName: 'English name',
  ChineseName2: 'Chinese name',
  FeeDetailsXls: 'Fee details.xls',
  UnitedNationsNumberAlreadyExists: 'United Nations number already exists',
  UserCannotBeEmpty: 'User cannot be empty',
  Yes: 'Yes',
  No: 'No',
  MergeInProgressPleaseWait: 'Merge in progress, please wait',
  YouExpectedToCompleteLater: 'You can leave this interface, the merge is expected to complete within 10 minutes, please check later',
  Note: 'Note',
  Success: 'Success',
  ChineseNameCannotBeEmpty: 'Chinese name cannot be empty',
  EmailFormatError: 'Email format error',
  ApplicableOrderRulescombinedName: 'Applicable Release Order Rules (combined) name',
  OnlyCanBeSetPort: 'Only one default designated freight agent can be set for the same destination port',
  UserCannotBeEmpty2: 'User cannot be empty!',
  DataIsIncorrectPleaseCheck: 'Data is incorrect, please check!',
  PleaseNumberYouWantDelete: 'Please select the booking number you want to delete!',
  PleaseSelectABranch: 'Please select a branch!',
  SiteNotSelected: 'Site not selected.',
  AlreadyAddedCannotAddRepeatedly: 'Already added, cannot add repeatedly!',
  AddedSuccessfully: 'Added successfully',
  SavedLibraryAlreadyExistsSave: 'Saved successfully, the following sensitive word library already exists, no need to save:',
  SavedWordsHaveBeenTimes: 'Saved successfully, the following sensitive words have been entered multiple times:',
  TheHaveBeenEnteredTimes: 'The following sensitive words have been entered multiple times:',
  FieldName: 'Field name',
  SensitiveWords: 'Sensitive words',
  Threshold: 'Sensitive word threshold',
  ThresholdTip: 'Sensitive word threshold indicates the fuzzy number of sensitive words, and 0 indicates 100% match check match.',
  EditedSuccessfully: 'Edited successfully',
  ChineseProductName: 'Chinese product name',
  EnglishProductName: 'English product name',
  ShippingMarks: 'Shipping marks',
  EmailRemindertestOnly: 'Email reminder (test only)',
  SplitDataBecomesNewData: 'Split (old data becomes new data)',
  SplittingDataAreYouSplit: 'Splitting will remove the original data, are you sure to split?',
  SplitSuccessfullySplitInto: 'Split successfully, split into',
  SensitiveWordManagement: 'Sensitive Word Management',
  CodeCannotBeEmpty: 'Code cannot be empty.',
  EnglishNameCannotBeEmpty: 'English name cannot be empty.',
  ContractConfiguration: 'Contract configuration',
  NoteTheReminderMethodIs: '>Note: the reminder method is',
  ReminderConfiguration: 'Reminder configuration:',
  ReminderRemaining: 'Reminder remaining',
  DaysBeforeTheDueDate: 'days before the due date',
  ReminderUser: 'Reminder user:',
  ContractAdministrator: 'Contract administrator',
  Sales: 'Sales',
  ProhibitionOfCreatingBusinessConfiguration: 'Prohibition of creating business configuration:',
  ContractAbleToCreateExpiration: 'Contract will not be able to create business after expiration',
  SavedSuccessfully: 'Saved successfully',
  CustomerLevel: 'Customer level',
  ContractStatus: 'Contract status',
  ContractType: 'Contract type',
  ExtensionCycle: 'Extension cycle',
  Partner: 'Partner',
  ContractNumber: 'Contract number',
  EffectiveDate: 'Effective date',
  ExpirationDate: 'Expiration date',
  ContractAgreement: 'Contract agreement',
  CustomerContract: 'Customer contract',
  SupplierContract: 'Supplier contract',
  OverseasAgentContract: 'Overseas agent contract',
  OtherContracts: 'Other contracts',
  ContractTerms: 'Contract terms',
  DeferredAfterExpiration: 'Deferred after expiration',
  N1Year: '1 year',
  N2Years: '2 years',
  N3Years: '3 years',
  Other: 'Other',
  OneClickRenewal: 'One-click renewal',
  Close: 'Close',
  AddContract: 'Add contract',
  EditContract: 'Edit contract',
  RenewContract: 'Renew contract',
  ViewContract: 'View contract',
  Contract: 'Contract',
  PartnerCannotBeEmpty: 'Partner cannot be empty.',
  ContractNumberCannotBeEmpty: 'Contract number cannot be empty.',
  EffectiveDateCannotBeEmpty: 'Effective date cannot be empty.',
  ExpirationDateCannotBeEmpty: 'Expiration date cannot be empty.',
  ContractAgreementCannotBeEmpty: 'Contract agreement cannot be empty.',
  unSupportContractCurrency: 'The direct or indirect exchange rate for "{0}" to "{1}" cannot be found. Please maintain the relevant exchange rate in a timely manner.',
  QuickSearchContractNumber: 'Quick search: contract number',
  LogRecord: 'Log record',
  Add: 'Add',
  HintSetToExpireDays: 'Hint: the system is set to expire within 30 days',
  OperationType: 'Operation type',
  Operator: 'Operator',
  Time: 'Time',
  EditField: 'Edit field',
  OriginalValue: 'Original value',
  NewValue: 'New value',
  AuditStatus: 'Audit status',
  OperationDate: 'Operation date',
  SettlementType: 'Settlement type',
  SettlementMethod: 'Settlement method',
  Limit: 'Limit',
  LimitCurrency: 'Limit currency',
  DateType: 'Date type',
  BillingCycle: 'Billing cycle',
  WhetherToPostpone: 'Whether to postpone',
  PostponementCycle: 'Postponement cycle',
  WhetherChapterHasBeenUploaded: 'Whether the booking chapter has been uploaded',
  WhetherAgreementHasBeenUploaded: 'Whether the contract agreement has been uploaded',
  Operation: 'Operation',
  Renewal: 'Renewal',
  Revoke: 'Revoke',
  TheAndTheOperationAllowed: 'The contract has been renewed and the operation is not allowed',
  DoYouNeedToUpdate: 'Do you need to update',
  ContractCreator: 'Contract creator',
  ContractCreationTime: 'Contract creation time',
  PartnerCreator: 'Partner creator',
  ContractAuditor: 'Contract auditor',
  ContractAuditTime: 'Contract audit time',
  PleaseSelectContractRecord: 'Please select contract record.',
  ContractRecordIsEmpty: 'Contract record is empty.',
  ContractRevocationSuccessful: 'Contract revocation successful.',
  QuickSearch: 'Quick search:',
  BulkRejection: 'Bulk rejection',
  All: 'All',
  Unaudited: 'Unaudited',
  Submitted: 'Submitted',
  Audited: 'Audited',
  PleaseSelectData: 'Please select data.',
  OnlySchemesWithAuditUnreviewed: 'Only expense plans with an approval status of Unsubmitted can be checked.',
  OnlySchemesWithAuditReviewed: 'Only check the cost schemes with audit status as reviewed.',
  OnlySchemesWithAuditSubmitted: 'Only check the cost schemes with audit status as submitted.',
  OnlyGuaranteeWithAuditUnreviewed: 'Only guarantee with an approval status of Unsubmitted can be checked.',
  OnlyGuaranteeWithAuditReviewed: 'Only check the guarantee with audit status as reviewed.',
  OnlyGuaranteeWithAuditSubmitted: 'Only check the guarantee with audit status as submitted.',
  GuaranteeFileIsNull: 'The guarantee documents are all empty',
  SelectGuaranteeFileIsNull: '{0} The guarantee document is empty',
  CodeDuplicatedPleaseReEnter: 'Code is duplicated, please re-enter.',
  Country: 'Country',
  CannotEditMultipleSchemes: 'Cannot edit multiple schemes.',
  CannotCopyMultipleSchemes: 'Cannot copy multiple schemes.',
  DeletedSuccessfully: 'Deleted successfully',
  PleaseEnterTheSchemeName: 'Please enter the scheme name',
  PleaseEnterTheStartingRow: 'Please enter the starting row',
  PleaseTheExcelCellName: 'Please fill in the Excel cell name',
  PleaseEnterTheSpaceProportion: 'Please enter the space proportion',
  EnglishName2: 'English name',
  UnknownType: 'Unknown type',
  SeaExport: 'Sea export',
  AirExport: 'Air export',
  BusinessTypeCannotBeEmpty: 'Business type cannot be empty.',
  OperationTypeCannotBeEmpty: 'Operation requirements type cannot be empty.',
  ContentDescriptionCannotBeEmpty: 'Content description cannot be empty.',
  OverseasWarehouse: 'Overseas warehouse',
  PartnerInformationImport: 'Partner information import',
  PleaseSelectTemplateType: 'Please select template type',
  PleaseSelectImportType: 'Please select import type',
  ImportTime: 'Import time',
  SelectDate: 'Select date',
  ImportResult: 'Import result',
  PleaseSelect: 'Please select',
  ImportType: 'Import type',
  ImportSuccessful: 'Import successful',
  DownloadTemplate: 'Download template',
  PartnerBasicInformation: 'Partner basic information',
  PartnerBillingHeaderInformation: 'Partner billing header information',
  Download: 'Download',
  ImportFile: 'Import file',
  SelectFile: 'Select file',
  ConfirmImport: 'Confirm import',
  ReminderPartnerBasicInformationFirst: 'Reminder: Please import partner basic information first',
  Search: 'Search',
  To: 'To',
  ContinueImport: 'Continue import',
  EnterPartnerInformation: 'Enter partner information',
  DownloadImportResult: 'Download import result',
  ViewFile: 'View file',
  SerialNumber: 'Serial number',
  LogFile: 'Log file',
  RemarkDescription: 'Remark description',
  AllSuccessful: 'All successful',
  AllFailed: 'All failed',
  PartiallySuccessfulPartiallyFailed: 'Partially successful, partially failed',
  TheOnlyBeXlsFormat: 'The uploaded file can only be xls, xlsx format!',
  ConfirmDeletionOfTheSite: 'Confirm deletion of the site?',
  TheByTheBusinessDeleted: 'The following sites are used by the business and cannot be deleted!',
  RailwayStation: 'Railway station',
  WhetherToOverwriteExistingData: 'Whether to overwrite existing data',
  PleaseDataYouWantExport: 'Please select the data you want to export.',
  FileBeLargerThan2MB: 'File size cannot be larger than 2MB',
  Items: 'item(s);',
  recordsImportedIntoTheSystem: '@records record(s) successfully imported into the system!',
  Items2: 'item(s)',
  PortOfLoadingPOL: 'Port of loading (POL)',
  PortOfDischargePOD: 'Port of discharge (POD)',
  PlaceOfDelivery: 'Place of delivery',
  ShippingCompany: 'Shipping company',
  DestinationPortAgent: 'Destination port agent',
  ShippingRoute: 'Shipping route',
  DisplayRules: 'Display rules',
  OperationalRequirements: 'Operational requirements',
  PleaseEnterTheContent: 'Please enter the content',
  AttachmentDescription: 'Attachment description',
  ViewAttachment: 'View attachment',
  WhetherToUseForMBL: 'Whether to use for MBL',
  WhetherToUseForHBL: 'Whether to use for HBL',
  AddPortRequirementsseaPort: 'Add port requirements (sea port)',
  PleaseARecordForEditing: 'Please select a record for editing',
  EditPortRequirementsseaPort: 'Edit port requirements (sea port)',
  PleaseARecordForDeletion: 'Please select a record for deletion',
  WhetherDeleteTheSelectedRecords: 'Whether to delete the selected records',
  Notice: 'Notice',
  DeletionCancelled: 'Deletion cancelled',
  DeletionFailed: 'Deletion failed!',
  DisplayRulesAreRequired: 'Display rules are required!',
  OperationalRequirementsAreRequired: 'Operational requirements are required!',
  SuccessfullyAddedPortRequirements: 'Successfully added port requirements',
  SuccessfullyModifiedPortRequirements: 'Successfully modified port requirements',
  MarksAndNumbers: 'Marks and Numbers',
  IMDGCODEImport: 'IMDG CODE import',
  PleaseUploadTxtFormatFile: 'Please upload txt format file!',
  SuccessfullyImported: 'Successfully imported',
  Items3: ' items',
  DangerousGoodsList: 'Dangerous goods list',
  NoteSystemReminder: 'Note: the reminder method is ""system reminder"", the system will remind again 2 days before the due',
  CustomerSignedRenewal: 'This customer has signed {0}, can choose this customer for renewal!',
  DuplicateBaseCurrencyValueExcel: 'Duplicate data in original currency value {0}, base currency value {0} and other data in Excel!',
  DuplicateCurrencyValue0Table: 'Duplicate data in original currency value {0}, base currency value {1} and existing data in the table!',
  DoOfThe00: 'Do you confirm the revocation of the \'{0}\' contract with \'{1}\'?',
  UploadPiecesUploadFailedPieces: 'Upload successful: {0} pieces, upload failed: {1} pieces.',
  DoWantToDelete0: 'Do you want to delete "{0}"?',
  TheValueIs0Excel: 'The original currency value is {0}, the base currency value is {1}, which is duplicated with other data in Excel!',
  TheIs0WhichTable: 'The original currency value is {0}, the base currency value is {1}, which is duplicated with existing data in the table!',
  ChargeGroup: 'Charge Group',
  DefaultWhtRate: 'Default WHT tax rate',
  ApplicableWhtTax: 'Applicable WHT tax',
  ApplicableWhtTaxTip: 'Applicable to the WHT (Withholding and Payment Tax) refund function in Thailand, which needs to be enabled in cooperation with the branch settings.',
  ExchangeRateDecimalPlaces: 'Exchange rate decimal places',
  SeaAirRoutes: 'Sea/air routes',
  AppliedSeaport: 'Applied Seaport',
  AppliedShippingCompany: 'Applied Shipping Company',
  ApplicationAirport: 'Application Airport',
  AppliedAirlines: 'Applied Airlines',
  VerificationItem: 'Verification item',
  SensitiveWordExists: 'Sensitive word library already exists',
  ClearCreditExpiration: 'Clear credit control after expiration',
  SubordinateCompanyPartners: 'Subordinate company partners',
  UncheckArApMate: 'Does not participate in AR/AP mapping',
  UncheckArApMateTip: 'After it is selected, this item will not participate in the verification of "Receivable including payable"',
  ExistCustomerVendorException: 'A customer supplier with the same name and code already exists, saved successfully',
  ExistCustomerCodeExcepiton: 'Customer with the same name and code already exists, saved successfully',
  ExistVendorCodeException: 'Supplier with the same name and code already exists, saved successfully',
  SyncCustomerCodeExcepiton: 'Abnormal synchronization of customer code, customer code cleared',
  SyncVendorCodeException: 'Abnormal synchronization of supplier code, supplier code cleared',
  mailing: 'Send and receive communication',
  SyncCustomerVendorException: 'Abnormal synchronization of customer and supplier codes, customer and supplier codes have been cleared',
  b2bWebsiteDisplayNotEmpty: 'B2B Website Display cannot be empty',
  IsItManualLaborCost: 'Is it manual labor cost?',
  FreeOfArCharge: 'Free of receivable charge',
  FreeOfApCharge: 'Free of payable charge',
  MergeAndDisplayToDesignatedFees: 'Merge and display to designated fees',
  MergeAndDisplayTips: 'At present, the current tenant only supports the consolidation and display of one set of expenses.',
  MergeAndDisplayToDesignatedFeesTips: 'For sales inquiries and remote booking modules, payable expenses are consolidated and displayed as specified expense names. At present, only one combination is supported and the cost is displayed.',
  operationTip: 'This operation cannot be undone after confirmation!!!!',
  MscService: 'Msc Service Code',
  PropulsionType: 'Propulsion Type',
  AircraftModel: 'Aircraft Model',
  UnitLoadDevice: 'Unit Load Device (ULD)'
}
